var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup159(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.159,
    y1: 0.159,
    x2: 0.887,
    y2: 0.887,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.554,
    x2: 0.5,
    y2: 0.995,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fea613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.783,
    y1: 0.549,
    x2: -0.366,
    y2: 0.477,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.199,
    y1: 0.199,
    x2: 0.905,
    y2: 0.905,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feaee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe2aa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.269,
    y1: -0.269,
    x2: 0.915,
    y2: 0.915,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 0.554,
    x2: 0.5,
    y2: 0.995,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#f70360",
    stopOpacity: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e40257",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e30256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.783,
    y1: 0.549,
    x2: -0.366,
    y2: 0.477,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a72b2b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.121,
    y1: 0.121,
    x2: 0.998,
    y2: 0.998,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3dafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: 0.554,
    x2: 0.5,
    y2: 0.995,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024c67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -0.143,
    y1: -0.143,
    x2: 1.252,
    y2: 1.252,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.314,
    y1: -0.314,
    x2: 0.749,
    y2: 0.749,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(-1020 -3175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 67,
    height: 67,
    rx: 15,
    transform: "translate(1020 3175)",
    fill: "#f6f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layers",
    transform: "translate(1033.914 3189.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(14.734 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M210.492,25.439H189.048a2,2,0,0,1-2-2V2a2,2,0,0,1,2-2h21.444a2,2,0,0,1,2,2V23.441A2,2,0,0,1,210.492,25.439Z",
    transform: "translate(-187.051 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M187.051,135.9v12.737a2,2,0,0,0,2,2h21.444a2,2,0,0,0,2-2V135.9Z",
    transform: "translate(-187.051 -125.193)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M407.269,99.336V116.95h6.095a2,2,0,0,0,2-2v-7.524Z",
    transform: "translate(-389.922 -91.511)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(7.367 7.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M116.967,118.965H95.523a2,2,0,0,1-2-2V95.523a2,2,0,0,1,2-2h21.444a2,2,0,0,1,2,2v21.444A2,2,0,0,1,116.967,118.965Z",
    transform: "translate(-93.526 -93.526)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M203.125,93.526H187.051V109.6a2,2,0,0,0,2,2h16.074V95.523A2,2,0,0,0,203.125,93.526Z",
    transform: "translate(-179.684 -93.526)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M93.526,229.423V242.16a2,2,0,0,0,2,2h21.444a2,2,0,0,0,2-2V229.423Z",
    transform: "translate(-93.526 -218.718)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M313.744,192.861v17.614h6.095a2,2,0,0,0,2-2v-7.524Z",
    transform: "translate(-296.397 -185.036)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 14.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M23.441,212.49H2a2,2,0,0,1-2-2V189.048a2,2,0,0,1,2-2H23.441a2,2,0,0,1,2,2v21.444A2,2,0,0,1,23.441,212.49Z",
    transform: "translate(0 -187.051)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M0,322.949v12.737a2,2,0,0,0,2,2H23.441a2,2,0,0,0,2-2V322.949Z",
    transform: "translate(0 -312.244)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M109.6,187.051H93.526v16.074a2,2,0,0,0,2,2H111.6V189.048A2,2,0,0,0,109.6,187.051Z",
    transform: "translate(-86.159 -172.317)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M197.756,189.048a2,2,0,0,0-2-2h-8.707v8.707a2,2,0,0,0,2,2h8.707Z",
    transform: "translate(-172.317 -172.317)",
    fill: "url(#linear-gradient-11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup159);
export default __webpack_public_path__ + "static/media/Group 159.50992cdb3e346e809bc68ba3eaed5172.svg";
export { ForwardRef as ReactComponent };